module.exports = __webpack_public_path__ + "castbox-478a06bad8a659d36370.svg";